var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLightbox = function SvgLightbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 105,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M45.573 11.78c-8.056-.118-14.568 6.133-14.747 14.017-.094 4.067 1.589 7.013 3.842 10.045 1.98 2.657 3.427 2.934 4.234 6.907M45.573 11.78c8.056-.118 14.563 6.133 14.747 14.017.093 4.067-1.59 7.013-3.843 10.045-1.98 2.657-3.72 2.93-4.527 6.907M51.946 42.749H51.9l-12.783.004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M45.573 52.528h3.418l2.955-4.89v-4.89M50.112 19.485c1.997 1.137 3.431 3.003 3.855 5.188M38.906 42.749v4.89l3.244 4.89h3.276"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M45.402 72.36v30.97M45.401 72.36l-29.88-14.942M45.402 72.36 34.795 87.3 4.914 72.36 15.52 57.419M45.402 72.36 55.776 87.39l29.885-14.943-10.379-15.028M45.402 72.36l29.88-14.942M45.401 103.33l-29.88-14.943v-9.78M45.402 103.33l29.88-14.943v-9.78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M45.426 2v3.26M28.136 9.16l2.307 2.306M20.977 26.45h3.26M28.136 43.739l2.307-2.306M62.712 43.739l-2.303-2.306M69.875 26.45h-3.26M62.712 9.16l-2.303 2.306"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M32.362 48.995 15.52 57.418M21.812 37.464 2 47.365l13.52 10.053M69.04 37.463l19.808 9.902L75.33 57.418M75.282 57.418l-16.816-8.41"
  })));
};
export default SvgLightbox;